import {ProjectFeatureFlag} from 'common/report/constants';
import type {CurrentProject} from 'common/report/model-resources/projects';
import {LineChartYAxisOptions} from 'common/charts/visualization/line-chart/types';
import {ChartType} from 'common/report/constants';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';
import {InsightsBookmarkParams} from 'common/report/insights/util/types';
import {getCountType} from 'common/report/insights/charts/funnels-step-chart/bookmark-controller/util';
import {CountType} from 'common/report/funnels/models/types';
import {isConversionOrRetentionRateMetric} from 'common/report/insights/models/utils';
import {ProjectDetails} from 'common/report/stores/project-details';

export function isChartCustomizationEnabled(currentProject: ProjectDetails | CurrentProject | null): boolean {
  return currentProject?.hasFeatureFlag(ProjectFeatureFlag.ChartCustomization) ?? false;
}

export function getYAxisDefaultOptions(
  bookmarkParams: InsightsBookmarkParams,
  bookmarkType: BookmarkType,
): LineChartYAxisOptions {
  const options: LineChartYAxisOptions = {};
  if (bookmarkType === BookmarkType.Insights || bookmarkType === BookmarkType.Retention) {
    // Handle adding % for lift comparison and conversion rate
    const isLiftComparison = `liftComparison` in bookmarkParams && Boolean(bookmarkParams.liftComparison);
    if (isLiftComparison || isConversionOrRetentionRateMetric(bookmarkParams)) {
      options.axisUnit = {suffix: `%`};
    }

    // Default softMin to 0 for Insights line charts
    if (bookmarkParams.displayOptions.chartType === ChartType.Line) {
      options.softMin = 0;
    } else if (
      /**
       * For ConversionColumnViz we technically only set an absolute min of 0 for
       * percentage values (conversion rate). We don't set a max of 1 but it will
       * make it clearer to the user that if they want to set a custom min/max
       * they should use values between 0-1 and not 0-100.
       */
      bookmarkParams.displayOptions.chartType === ChartType.FunnelSteps &&
      getCountType(bookmarkParams.sections.show) === CountType.ConversionRate
    ) {
      options.axisUnit = {
        suffix: `%`,
      };
      options.softMin = 0;
      options.softMax = 1;
    }
  }
  return options;
}
